module.exports = __webpack_public_path__ + "static/media/Shopster.a53ec802.svg";